import { render, staticRenderFns } from "./WordImportTable.vue?vue&type=template&id=6bad07e3&scoped=true&lang=html&"
import script from "./WordImportTable.vue?vue&type=script&lang=js&"
export * from "./WordImportTable.vue?vue&type=script&lang=js&"
import style0 from "./WordImportTable.vue?vue&type=style&index=0&id=6bad07e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad07e3",
  null
  
)

export default component.exports